// proto/v2/billing/billing.proto
//
// Billing queries over WS — Wave 5 HTTP→WS migration. Previously served
// over HTTP at /api/v1/billing/balance (see internal/billing/handler.go).
// Only the read-only balance endpoint is migrated; checkout stays HTTP
// indefinitely (needs to return a redirect URL to Polar.sh), and webhook
// is external-inbound.
//
// Budget events live in proto/v2/budget (per-user credit lifecycle — that
// payload is `double balance`, fired as push events). This package is
// distinct: org-scoped balance, integer cents, pulled on demand by
// billing UI components.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file billing/billing.proto (package lvdr.v2.billing, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file billing/billing.proto.
 */
export const file_billing_billing: GenFile = /*@__PURE__*/
  fileDesc("ChViaWxsaW5nL2JpbGxpbmcucHJvdG8SD2x2ZHIudjIuYmlsbGluZyIqChhHZXRCaWxsaW5nQmFsYW5jZVJlcXVlc3QSDgoGb3JnX2lkGAEgASgJIjkKFkJpbGxpbmdCYWxhbmNlUmVzcG9uc2USDgoGb3JnX2lkGAEgASgJEg8KB2JhbGFuY2UYAiABKANCKFomZ2l0aHViLmNvbS9ndnM0Mi9sdmRyL3Byb3RvL3YyL2JpbGxpbmdiBnByb3RvMw");

/**
 * @generated from message lvdr.v2.billing.GetBillingBalanceRequest
 */
export type GetBillingBalanceRequest = Message<"lvdr.v2.billing.GetBillingBalanceRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message lvdr.v2.billing.GetBillingBalanceRequest.
 * Use `create(GetBillingBalanceRequestSchema)` to create a new message.
 */
export const GetBillingBalanceRequestSchema: GenMessage<GetBillingBalanceRequest> = /*@__PURE__*/
  messageDesc(file_billing_billing, 0);

/**
 * @generated from message lvdr.v2.billing.BillingBalanceResponse
 */
export type BillingBalanceResponse = Message<"lvdr.v2.billing.BillingBalanceResponse"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: int64 balance = 2;
   */
  balance: bigint;
};

/**
 * Describes the message lvdr.v2.billing.BillingBalanceResponse.
 * Use `create(BillingBalanceResponseSchema)` to create a new message.
 */
export const BillingBalanceResponseSchema: GenMessage<BillingBalanceResponse> = /*@__PURE__*/
  messageDesc(file_billing_billing, 1);

